import React from "react"

import type { IPopupProps } from "@front-shared/types/props.types"

import { NETWORK_STATUS_CONFIG } from "../../config/networkStatus.config"
import { NetworkStatusRulesCsvHelper } from "../../helpers/networkStatusRulesCsv.helper"
import { useAppDispatch } from "../../store/appDispatch.hook"
import { useAppSelector } from "../../store/selectors/app.selector"
import { selectedPracticeRoleSelector } from "../../store/selectors/selectedPracticeRole.selector"
import { networkStatusValidateRules } from "../../store/thunks/networkStatus.thunks"
import type { IReviewNewRulesLocationState } from "../../types/networkStatus.types"
import { BulkUploadPopupComponent } from "./bulkUploadPopup.component"

export const NetworkStatusRulesBulkUploadPopupComponent: React.FunctionComponent<
    INetworkStatusRulesBulkUploadPopupComponentProps
> = props => {
    const dispatch = useAppDispatch()
    const selectedPracticeRole = useAppSelector(selectedPracticeRoleSelector)

    return (
        <BulkUploadPopupComponent
            isActive={props.isActive}
            className={props.className}
            closeOnOutsideClick={props.closeOnOutsideClick}
            onDone={props.onDone}
            title="Add bulk new rules"
            description="Import multiple network rules at once with a CSV."
            dropzoneLabel="Add Network Rules CSV"
            importButtonLabel="Import rules"
            parsingLabel="Parsing your network rules..."
            templateUrl={NETWORK_STATUS_CONFIG.csvTemplateUrl}
            disabled={!selectedPracticeRole}
            parseCsv={NetworkStatusRulesCsvHelper.parse}
            onValidate={(rules, file, callbacks) => {
                if (!selectedPracticeRole) {
                    callbacks.onError()

                    return
                }

                dispatch(
                    networkStatusValidateRules({
                        practice: selectedPracticeRole.practice,
                        payload: { rules },
                        onSuccess: result => {
                            props.onValidationDone({
                                rules,
                                errors: result?.errors ?? [],
                                filename: file.name,
                                totalRowCount: rules.length,
                            })

                            callbacks.onSuccess()
                        },
                        onError: callbacks.onError,
                    }),
                )
            }}
        />
    )
}

interface INetworkStatusRulesBulkUploadPopupComponentProps extends IPopupProps {
    onValidationDone: (data: IReviewNewRulesLocationState) => void
}
